import type { CSSProperties } from 'react';

import { cn } from '@/shared/lib/utils';

interface FieldLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

/**
 * Field label primitive in the Phoenix style — `text-phx-xs` (11px) muted-2 label
 * with an optional required asterisk. Menší varianta dle design sekce `comp-inputs`,
 * ale sentence case (bez vynuceného UPPERCASE).
 */
export function FieldLabel({
  htmlFor,
  children,
  required,
  disabled,
  className,
  style,
}: FieldLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      style={style}
      className={cn(
        'phx-label text-phx-xs text-phx-text-2 font-medium select-none',
        disabled && 'cursor-not-allowed opacity-70',
        className
      )}
    >
      {children}
      {required && (
        <span aria-hidden className="text-phx-danger ml-0.5">
          *
        </span>
      )}
    </label>
  );
}
